import { Grid, styled } from '@mui/material';
import { Checkbox, Text } from 'library';
import React, { useState, useEffect } from 'react';
import { client, consoleLogInDev } from 'shared';

interface ILocationType {
    id: number;
    name: string;
}

interface ILocationTypesProps {
    selectedTypes: number[];
    setSelectedTypes: (val: number[]) => void;
}

export default function LocationTypes({ selectedTypes, setSelectedTypes }: ILocationTypesProps) {
    const [locationTypes, setLocationTypes] = useState<ILocationType[]>([]);

    useEffect(() => {
        client('api/business-location-type/')
            .then((response: ILocationType[]) => {
                setLocationTypes(response);
            })
            .catch(consoleLogInDev);
    }, []);

    function onTypeSelect(id: number) {
        if (selectedTypes.includes(id)) {
            setSelectedTypes(selectedTypes.filter((x) => x !== id));
        } else {
            setSelectedTypes([...selectedTypes, id]);
        }
    }

    return (
        <Grid>
            <Text bold>What type of program(s) do you operate?</Text>
            <CheckContainer container>
                {locationTypes.map((x) => (
                    <Grid key={x.id} item sm={6} xs={12}>
                        <Checkbox
                            label={x.name}
                            checked={selectedTypes.includes(x.id)}
                            onChange={() => onTypeSelect(x.id)}
                        />
                    </Grid>
                ))}
            </CheckContainer>
        </Grid>
    );
}

const CheckContainer = styled(Grid)({
    paddingTop: 10,
});
